module.exports = __webpack_public_path__ + "img/yun.b58bb644.png";